import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import styles from '@dtsl/css-status/dist/index.module.css';
function Status(props) {
  const {
    indicator,
    label,
    inlineStyles,
    className
  } = props;
  const statusClass = classNames({
    [styles['sib-status']]: true,
    [className]: !!className
  });
  return /*#__PURE__*/React.createElement("span", {
    className: statusClass,
    style: inlineStyles
  }, /*#__PURE__*/React.createElement("span", {
    className: styles['status__indicator'],
    style: {
      backgroundColor: indicator
    }
  }), label && /*#__PURE__*/React.createElement("span", {
    className: styles['status__label']
  }, label));
}
Status.defaultProps = {
  label: null,
  indicator: 'var(--sib-color_primary-default, #0071c7)',
  inlineStyles: {},
  className: ''
};
Status.propTypes = {
  label: PropTypes.string,
  indicator: PropTypes.string,
  inlineStyles: PropTypes.object,
  className: PropTypes.string
};
export default Status;